import axios from "axios";
import { useStore } from "../appStore";
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { errorToast, successToast } from "../../constants/toast";

async function updateRolePermissions(orgId, updateData) {
    const response = await axios.put(`/api/Organization/${orgId}/Roles/${updateData.organizationalRoleId}`, updateData);
    return response.data;
}

const useUpdateRolePermissionsMutation = () => {
    const queryClient = useQueryClient()
    const orgId = useStore((state) => state.CurrentOrganizationId);

    return useMutation({
        mutationFn: async (payload) => await updateRolePermissions(orgId, payload.updateData),
        onSuccess: (data, payload) => {
            //add the new record to cache
            queryClient.setQueryData(['permissionRoles', payload.updateData.organizationalRoleId, orgId], (previousData) => {
                return {
                    ...previousData,
                    organizationalRoleType: data.organizationalRoleType,
                    roleName: data.roleName,
                    organizationalRoleId: data.organizationalRoleId,
                    permissionList: data.permissionList
                }
            });

            queryClient.setQueryData(["organizationalRoles", orgId], (prevData) => {
                return prevData.map((item) => {
                    if (item.organizationalRoleId === payload.updateData.organizationalRoleId) {
                        return {
                            ...item,
                            roleName: data.roleName,
                            lastUpdated: data.lastUpdated
                        }
                    }
                    return item;
                });
            });
            payload.makeToast?.("Successfully updated data", successToast)
        },
        onError: (error, payload) => {
            payload.makeToast?.(error?.message || "update failed", errorToast);
        }
    })
}

export { useUpdateRolePermissionsMutation }